import React from "react";

import { useBooleanState } from "hooks";
import { useFeatures } from "components/FeatureFlag";

import { useAddUserStep, useSkipAddUser } from "./hooks";
import {
  ContainerVariant,
  MultipleStepsWrapper,
  NewUserInfoPage,
  SkipAddUserModal,
  SubscriptionInformationPage,
} from "./components";

function AddUserStep() {
  const {
    classes,
    loading: submitting,
    loadingNotInvitedUser,
    isCompletingSetup,
    userInfos,
    initializing,
    onSubmit,
    onCloseWithNotify,
    setUserInfos,
  } = useAddUserStep();

  const {
    setUnsavedUserData,
    setUnsavedUserError,
    shouldShowSkipConfirmation,
    getValidUser,
  } = useSkipAddUser();

  const [showSkipConfirmation, open, close] = useBooleanState();
  const addUserOnboardingFF = useFeatures("add-user-during-onboarding");

  if (initializing) return null;

  return (
    <div style={{ display: "flex", gap: "1em", flexDirection: "column" }}>
      <div data-test="add-user-step" className={classes.addUserContainer}>
        <MultipleStepsWrapper>
          <NewUserInfoPage
            defaultNewUserInfo={userInfos}
            loadingNotInvitedUser={loadingNotInvitedUser}
            onChange={setUserInfos}
            onClose={onCloseWithNotify}
            containerVariant={ContainerVariant.DIV}
            addUserTitle={addUserOnboardingFF?.inviteTitle}
            addUserDescription={addUserOnboardingFF?.inviteDescription}
            addUserButtonText={addUserOnboardingFF?.addButtonText}
            hideInviteNowColumn
            onUnsavedDataChange={setUnsavedUserData}
            onUnsavedDataErrorChange={setUnsavedUserError}
          />
          <SubscriptionInformationPage
            inviteCount={
              userInfos.filter((userInfo) => {
                return userInfo.inviteNow;
              }).length
            }
            containerVariant={ContainerVariant.DIV}
            loading={submitting || isCompletingSetup}
            onSubmit={onSubmit}
            onClose={onCloseWithNotify}
            agreeButtonText={addUserOnboardingFF?.agreeButtonText}
            title={addUserOnboardingFF?.subscriptionInformationPageTitle}
            ssaUrl={addUserOnboardingFF?.ssaUrl}
            trialInfoText={addUserOnboardingFF?.trialInfoText}
          />
        </MultipleStepsWrapper>
      </div>
      <button
        type="button"
        onClick={() => {
          return shouldShowSkipConfirmation() ? open() : onCloseWithNotify();
        }}
        disabled={submitting || isCompletingSetup}
        className={classes.skipButton}
      >
        {addUserOnboardingFF?.skipText || "Skip Add User"}
      </button>
      {showSkipConfirmation && (
        <SkipAddUserModal
          onClose={close}
          loading={submitting || isCompletingSetup}
          onAddUser={async ({ inviteNow }) => {
            if (!inviteNow) {
              const validData = getValidUser();
              if (validData?.length) await onSubmit(validData);
            }

            close();
          }}
        />
      )}
    </div>
  );
}

export default AddUserStep;
